import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import ContactForm from '../components/ContactForm';
import { getCdnImage } from '../lib/imageUtils';

export default function Home() {

  const services = [
    {
      title: 'Vandværksservice & ledningsarbejde',
      desc: 'Professionelt gravearbejde og akut assistance ved rørskader, nedgravning af målerbrønde og stikledninger for vandværker.',
      icon: 'fa-solid fa-faucet-drip',
      link: '/ydelser/vandvaerksservice-ledningsarbejde',
      image: 'https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/imgi-94-605221099-1366670058493953-1062181551945056561-n.jpg',
    },
    {
      title: 'Autoriseret kloakarbejde & tilslutning',
      desc: 'Alt inden for autoriseret kloakmesterarbejde: kloaktilslutning, pumpestationer, samletanke, rottespærrer og systematisk fejlfinding.',
      icon: 'fa-solid fa-water',
      link: '/ydelser/kloakarbejde-tilslutning',
      image: 'https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/imgi-94-601820261-1366670001827292-7586379579870585065-n.jpg',
    },
    {
      title: 'Belægning & anlæg',
      desc: 'Holdbare belægningsløsninger, herregårdssten, fliser og professionel laserstyret bundopbygning for optimal holdbarhed.',
      icon: 'fa-solid fa-layer-group',
      link: '/ydelser/belaegning-anlaeg',
      image: 'https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/imgi-94-481666921-1140782317749396-168441956002480996-n.jpg',
    },
    {
      title: 'Vinterservice & snerydning',
      desc: 'Pålidelig snerydning og saltning af parkeringspladser og tilkørselsveje for forretninger, virksomheder og institutioner.',
      icon: 'fa-solid fa-snowflake',
      link: '/ydelser/vinterservice-snerydning',
      image: 'https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/imgi-94-613121285-1380287927132166-3828401678356812271-n.jpg',
    },
  ];

  return (
    <div className="bg-slate-50 min-h-screen">
      <SeoMeta
        title="ENTREPRENØR LANG ApS | Aut. kloakmester & entreprenør"
        description="aut kloakmester"
        keywords="kloak, gravearbejde,snerydning, glatførebekæmpelse, vandværksservice, belægning, Øster Ulslev"
      />

      {/* HERO SECTION */}
      <section className="relative bg-slate-950 text-white overflow-hidden">
        {/* Background Image with optimized dark overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src={getCdnImage('https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/sneberedskab3.jpg', {
              width: 1920,
              quality: 85,
            })}
            alt="ENTREPRENØR LANG entreprenørarbejde og maskiner"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-950/85 to-slate-900/60" />
          <div className="absolute inset-0 bg-radial-at-c from-emerald-950/30 to-transparent pointer-events-none" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
          <div className="max-w-3xl space-y-6">
            {/* Tagline Badge */}
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-500/20 text-emerald-300 text-xs sm:text-sm font-semibold border border-emerald-500/30 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              <span>Aut. kloakmester & entreprenør siden 2005</span>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.1]">
              ENTREPRENØR LANG ApS
            </h1>

            <p className="text-lg sm:text-xl text-slate-200 font-medium leading-relaxed max-w-2xl">
              Specialist i professionel vandværksservice, autoriseret kloakarbejde, kvalitetsbelægning og effektiv vinterservice. Grundlagt på solidt håndværk og ordentlige aftaler.
            </p>

            {/* CTAs */}
            <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <Link
                to="/kontakt-os"
                className="inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-base shadow-lg shadow-emerald-900/40 transition-all hover:-translate-y-0.5"
              >
                <span>Få et tilbud</span>
                <i className="fa-solid fa-arrow-right text-sm" aria-hidden="true" />
              </Link>

              <Link
                to="/galleri"
                className="inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-xl bg-slate-800/90 hover:bg-slate-700/90 text-white font-bold text-base border border-slate-700 backdrop-blur-sm transition-all hover:-translate-y-0.5"
              >
                <span>Se galleri</span>
                <i className="fa-solid fa-images text-sm text-emerald-400" aria-hidden="true" />
              </Link>

              <a
                href="tel:40309708"
                className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-xl bg-white/10 hover:bg-white/20 text-white font-bold text-base border border-white/20 backdrop-blur-sm transition-all whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-emerald-400" aria-hidden="true" />
                <span className="whitespace-nowrap">Tlf: 40 30 97 08</span>
              </a>
            </div>

            {/* Quality Seals Bar */}
            <div className="pt-8 border-t border-slate-800/80 flex flex-wrap items-center gap-6 text-xs text-slate-300">
              <div className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-emerald-400 text-base" aria-hidden="true" />
                <span>Autoriseret kloakmester</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-emerald-400 text-base" aria-hidden="true" />
                <span>Byggeriets Kvalitetskontrol</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="fa-solid fa-circle-check text-emerald-400 text-base" aria-hidden="true" />
                <span>Garanti</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CORE SERVICES SECTION (4 main areas) */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider mb-3">
            <i className="fa-solid fa-toolbox text-xs" aria-hidden="true" />
            Vores fagområder
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Komplette entreprenørløsninger
          </h2>
          <p className="text-slate-600 text-base sm:text-lg mt-3">
            Vi udfører specialiseret grave- og ledningsarbejde for vandværker samt kloak, belægning og snerydning for private og erhverv.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {services.map((svc) => (
            <Link
              key={svc.link}
              to={svc.link}
              className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl hover:border-emerald-600/50 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Image preview - higher on desktop */}
              <div className="relative h-56 md:h-64 lg:h-72 overflow-hidden bg-slate-100">
                <img
                  src={getCdnImage(svc.image, { width: 800, height: 600, fit: 'cover' })}
                  alt={svc.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Body */}
              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-800 transition-colors leading-snug">
                    {svc.title}
                  </h3>
                  <p className="text-slate-600 text-xs sm:text-sm mt-2 leading-relaxed">
                    {svc.desc}
                  </p>
                </div>

                <div className="pt-5 mt-4 border-t border-slate-100 flex items-center justify-between text-xs sm:text-sm font-bold text-emerald-700 group-hover:text-emerald-800">
                  <span>Læs mere om ydelsen</span>
                  <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* SCRAPE VERBATIM STORY SECTION */}
      <section className="py-16 bg-white border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left text - verbatim from scrape */}
            <div className="lg:col-span-7 space-y-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-100 text-slate-800 text-xs font-bold uppercase tracking-wider">
                <i className="fa-solid fa-history text-xs text-emerald-600" aria-hidden="true" />
                Velkommen til ENTREPRENØR LANG
              </span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
                Velkommen
              </h2>

              <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed text-base space-y-4">
                <p>
                  Entreprenør Lang blev oprettet i marts 2005 af Martin Hovmand Lang, som valgte at starte firmaet helt fra bunden.
                </p>
                <p>
                  Firmaet blev startet som et enmandsfirma, hvilket det fortsat er.
                </p>
                <p>
                  Firmaet drives fra adressen Karlebyvej 32, 4894 Øster Ulslev, som også er hjem adresse for familien Lang.
                </p>
                <p>
                  Da vi startede i 2005 var kloak og drænarbejde samt jord og beton og belægning, men det har ændret sig lidt da der er blevet meget gravearbejde for vandværker ved brud, skiftning af målerbrønde, afpropning af stik osv.
                </p>
                <p>
                  Udover kloak- og drænarbejde har vi også meget saltning og snerydning i vintermånederne ved parkeringsarealer for forretninger og virksomheder.
                </p>
              </div>

              <div className="pt-4 flex flex-wrap items-center gap-4">
                <Link
                  to="/om-os"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-colors"
                >
                  <span>Læs mere om os</span>
                  <i className="fa-solid fa-arrow-right text-xs text-emerald-400" aria-hidden="true" />
                </Link>
                <a
                  href="tel:40309708"
                  className="inline-flex items-center gap-2 text-slate-900 hover:text-emerald-700 font-bold text-sm px-4 py-3 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-emerald-600" aria-hidden="true" />
                  <span className="whitespace-nowrap">Ring: 40 30 97 08</span>
                </a>
              </div>
            </div>

            {/* Right authentic workshop image & badges */}
            <div className="lg:col-span-5 space-y-6">
              <div className="relative rounded-2xl overflow-hidden shadow-xl border border-slate-200">
                <img
                  src={getCdnImage('https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/firma2.jpg', {
                    width: 800,
                    quality: 85,
                  })}
                  alt="ENTREPRENØR LANG ApS Karlebyvej 32 Øster Ulslev"
                  className="w-full h-80 object-cover"
                />
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-slate-950/90 via-slate-950/60 to-transparent p-4 text-white">
                  <p className="text-xs uppercase tracking-wider text-emerald-400 font-bold">Virksomhedens base</p>
                  <p className="text-sm font-semibold">Karlebyvej 32, 4894 Øster Ulslev</p>
                </div>
              </div>

              {/* Trust Badges */}
              <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col items-center justify-center text-center">
                <img
                  src={getCdnImage('https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/dme-kloakmestergaranti.webp', {
                    width: 480,
                    quality: 90,
                  })}
                  alt="DM&E Kloakmestergaranti"
                  className="h-24 w-auto object-contain mb-3"
                />
                <span className="text-xs font-semibold text-slate-700">DM&E Garantiordning</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION WITH FORM */}
      <section
        className="py-20 text-white relative overflow-hidden bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('https://assets.auxodev.dk/assets/7d468145-c8f2-4ea0-936d-cc188f08bb8a/hero-entreprenor-gravemaskine.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-[1px]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Left Contact Info */}
            <div className="lg:col-span-5 space-y-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-wider border border-emerald-500/30">
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                Direkte kontakt
              </span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                Kontakt ENTREPRENØR LANG ApS
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Hvad enten du repræsenterer et vandværk, en virksomhed eller er privat grundejer, står vi klar til at hjælpe med dit projekt.
              </p>

              <div className="space-y-4 pt-2">
                <div className="flex items-start gap-4 p-4 rounded-xl bg-slate-800/80 border border-slate-700">
                  <div className="w-10 h-10 rounded-lg bg-emerald-600/20 text-emerald-400 flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-phone text-base" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-xs text-slate-400 uppercase font-semibold">Ring direkte</div>
                    <a
                      href="tel:40309708"
                      className="text-lg font-bold text-white hover:text-emerald-400 transition-colors whitespace-nowrap"
                    >
                      40 30 97 08
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl bg-slate-800/80 border border-slate-700">
                  <div className="w-10 h-10 rounded-lg bg-emerald-600/20 text-emerald-400 flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-envelope text-base" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-xs text-slate-400 uppercase font-semibold">Send en e-mail</div>
                    <a
                      href="mailto:martinl4894@gmail.com"
                      className="text-base font-bold text-white hover:text-emerald-400 transition-colors whitespace-nowrap block"
                    >
                      martinl4894@gmail.com
                    </a>
                    <span className="text-xs text-slate-400">Martin@entreprenorlang.dk</span>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl bg-slate-800/80 border border-slate-700">
                  <div className="w-10 h-10 rounded-lg bg-emerald-600/20 text-emerald-400 flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-location-dot text-base" aria-hidden="true" />
                  </div>
                  <div>
                    <div className="text-xs text-slate-400 uppercase font-semibold">Adresse & Værksted</div>
                    <p className="text-sm font-semibold text-white">Karlebyvej 32, 4894 Øster Ulslev</p>
                    <p className="text-xs text-slate-400 mt-0.5">CVR: 28498675</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm defaultService="Vandværksservice & ledningsarbejde" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
